import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';
import { personalInfo } from '../../data/mock';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative py-12 border-t border-[rgba(255,255,255,0.05)] z-10">
      {/* Background watermark */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none">
        <span className="font-display text-[6vw] font-extrabold text-[rgba(255,255,255,0.025)] whitespace-nowrap select-none">
          NIHANTH NAIDU K
        </span>
      </div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="font-mono text-sm text-[#8892A4]">
            &copy; {year} <span className="text-[#C0C8D8] font-semibold">Nihanth Naidu K</span>
          </p>

          {/* Social icons */}
          <div className="flex gap-4">
            <a
              href={personalInfo.githubUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-[#8892A4] hover:text-[#00D4FF] hover:border-[rgba(0,212,255,0.3)] transition-all duration-300"
            >
              <Github size={18} />
            </a>
            <a
              href={personalInfo.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-[#8892A4] hover:text-[#00D4FF] hover:border-[rgba(0,212,255,0.3)] transition-all duration-300"
            >
              <Linkedin size={18} />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              aria-label="Email"
              className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-[#8892A4] hover:text-[#00D4FF] hover:border-[rgba(0,212,255,0.3)] transition-all duration-300"
            >
              <Mail size={18} />
            </a>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
